import { PricingTypes, ProjectStatus, VisitWorkareaStatus } from '../../common/constants'
import { Job, VisitWorkareaStatusRecord, Workarea } from "./editVisitApi"

export type StatusChange = {
  workareaId: number
  status: VisitWorkareaStatus
}

export type JobStatusChange = {
  workareaId: number
  status: ProjectStatus
}

export type Status = {
  name: string
  status?: VisitWorkareaStatus
  changed: boolean
  jobId?: number
  workareaId?: number
}

export const buildStatusList = (job: Job, visitWorkareaStatuses: VisitWorkareaStatusRecord[], state: StatusChange[], workareaIds: number[]): Status[] => {
  return workareaIds.map(workareaId => {
    const workarea = job.workareas.find(x => x.id === workareaId)
    const visitWorkareaStatus = visitWorkareaStatuses.find(x => x.workareaId === workareaId)
    const change = state.find(x => x.workareaId === workareaId)
    const status = change?.status ?? visitWorkareaStatus?.status
    return {
      workareaId,
      status,
      changed: status !== visitWorkareaStatus?.status,
      name: workarea?.name ?? ''
    }
  })
}

export const updateStatus = (state: StatusChange[], update: StatusChange): StatusChange[] => {
  if (state.some(x => x.workareaId === update.workareaId)) {
    return state.map(x => x.workareaId === update.workareaId ? { ...x, status: update.status } : x)
  }
  return [...state, update]
}

export const updateJobStatus = (state: JobStatusChange[], update: JobStatusChange): JobStatusChange[] => {
  if (state.some(x => x.workareaId === update.workareaId)) {
    return state.map(x => x.workareaId === update.workareaId ? { ...x, status: update.status } : x)
  }
  return [...state, update]
}

export const isRecurringWorkarea = (workarea: Workarea): boolean => {
  try {
    return workarea.recurringScheduleConfig !== undefined &&
      (JSON.parse(workarea.recurringScheduleConfig)?.isRecurring ?? false)
  } catch {
    return false
  }
}

export const getWorkareaIdsThatShouldShowStatus = (job: Job): number[] => {
  return job.workareas.filter(x => isRecurringWorkarea(x) || x.pricingType === PricingTypes.PerVisit).map(x => x.id)
}

export const getWorkareaIdsThatShouldShowJobStatus = (job: Job): number[] => {
  return job.workareas.filter(x => !isRecurringWorkarea(x) && x.pricingType !== PricingTypes.PerVisit).map(x => x.id)
}